import React, { memo } from 'react'
import { useDepartmentCard, DepartmentCardProps } from './useDepartmentCard'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './DepartmentCard.module.scss'

const DepartmentCard: React.FC<DepartmentCardProps> = (
  props: DepartmentCardProps
) => {
  const { title, description, url, image, isAr, t } = useDepartmentCard(props)

  return (
    <Link to={url} style={{ textDecoration: 'none' }}>
      <div className={`${styles['department-card']} position-relative h-100`}>
        <div className={styles['icon-container']}>
          <img src={image} width={150} height={150} alt='logo' />
        </div>
        <h3>{title}</h3>
        <p>{description}</p>
        <h5>
          {t('readMore')}{' '}
          <FontAwesomeIcon
            icon={['fas', isAr ? 'arrow-left' : 'arrow-right']}
            className={styles.icon}
          />
        </h5>
      </div>
    </Link>
  )
}

export default memo(DepartmentCard)
